<template>
  <div class="card m-order-detail">
  <p class="m-order-detail-title color-primary "
     style="font-size: 16px">{{ getName(order.OrderDesc)}}</p>
  <p v-if="order.OrderType">{{states.dataSources[order.ListType]}} List</p>

  <p><br>ZIP</p>
  <p  v-for = "item in orderDetail.OrderAddresses"
      class="m-order-detail-item">
                <span v-if="item.ZipCode">
                {{item.ZipCode}}
                </span>
  </p>
  <p if="order.XIpCode">
    {{order.ZipCode}}
  </p>

  </div>
</template>

<script>
  export default {
    props: ['order'],
    data () {
      return {
        states: this.$store.state.user,
        detail: {OrderAddresses: []}
      }
    },
    computed: {
      orderDetail () {
        if (this.detail.OrderAddresses.length === 0) {
          this.$http.post('dialogs/OrderDetails.aspx/GetOrder', {
            sessionId: this.order.SessionGuid
          }).then(resp => {
            if (resp.body.d.ResultFlag) {
              this.detail = resp.body.d.DataSource.Order
            } else {
            }
          }, resp => {
          })
        }
        return this.detail
      }
    },
    methods: {
      getName (v) {
        if (v.length > 32) {
          return v.substring(0, 29) + '...'
        } else {
          return v
        }
      }
    }
  }
</script>

<style scoped>
  .m-order-detail {
    position: absolute;
    top: 65px;
    left: 65px;
    line-height: 0.5;
    color:  #B0B0B0;
    min-width: 250px;
    padding:20px;
    font-size: 0.9em;
    transition: box-shadow .25s, -webkit-box-shadow .25s;
    -webkit-transition: -webkit-box-shadow .25s;
    transition: -webkit-box-shadow .25s;
    transition: box-shadow .25s;
    border-radius: 2px;
    background-color: #fff;
    display:none;
    z-index: 100;
  }
  .m-order-detail-title{
    font-size: 1em;
  }
  .m-order-detail-item{
    margin-left: 24px;
  }

</style>



// WEBPACK FOOTER //
// src/components/landings/MOrderDetail.vue